<template>
  <div>
    <a-table :columns="visibleColumns"
      :data-source="list"
      :pagination="pagination"
      :loading="showLoading"
      :rowClassName="inbreedingRowClass"
      @change="handleTableChange"
      @expand="onExpand">
      <div slot="expandedRowRender" slot-scope="record" style="margin: 0" expandIcon="">
        <yu-zhong-chart-result :male_id="male_item.id" :female_id="record.id" :ref="`result-${record.vid}`"></yu-zhong-chart-result>
      </div>
      <template slot="father" slot-scope="father, row">
        <item-button :text="row.item_father" :id="row.father_id" :is_dead="row.is_dead"></item-button>
      </template>
      <template slot="mother" slot-scope="mother, row">
        <item-button :text="row.item_mother" :id="row.mother_id" :is_dead="row.is_dead"></item-button>
      </template>
      <template slot="vid" slot-scope="vid, row">
        <item-button :text="row.vid" :id="row.id" :is_dead="row.is_dead"></item-button>
      </template>
      <template slot='export_tag' slot-scope="export_tag">
        {{ export_tag || '-'}}
      </template>
      <template slot="state" slot-scope="scope, row">
        <a-tag color="grey" v-if="row.state == null">{{ row.state_text }}</a-tag>
        <a-tag color="blue" v-if="row.state == 1">{{ row.state_text }}</a-tag>
        <a-tag color="green" v-if="row.state == 2">{{ row.state_text }}</a-tag>
        <a-tag color="red" v-if="row.state == 3">{{ row.state_text }}</a-tag>
      </template>
      <template slot='gebv_volume' slot-scope="gebv_volume">
        {{ gebv_volume || '-'}}
      </template>
      <template slot="predicted_offspring_f" slot-scope="predicted_offspring_f">
        <span :style="{ color: getInbreedingColor(predicted_offspring_f) }">
          {{ formatInbreeding(predicted_offspring_f) }}
        </span>
        <a-tooltip v-if="useInbreedingAlgo && getInbreedingLevel(predicted_offspring_f) === 'warning'" placement="top">
          <template slot="title">
            注意，存在一定近交风险，请确保父本的育种值（EBV）足够优秀以覆盖风险
          </template>
          <a-tag color="orange" style="margin-left: 4px; font-size: 11px; cursor: pointer;">警告</a-tag>
        </a-tooltip>
        <a-tooltip v-if="useInbreedingAlgo && getInbreedingLevel(predicted_offspring_f) === 'danger'" placement="top">
          <template slot="title">
            预测后代近交系数超过 6.25%，强烈不建议此配对
          </template>
          <a-tag color="red" style="margin-left: 4px; font-size: 11px; cursor: pointer;">禁止</a-tag>
        </a-tooltip>
      </template>
      <template slot="operation" slot-scope="scope">
        <a-dropdown>
          <a-menu slot="overlay" @click="(e) => handleItemAction(e, scope)">
            <a-menu-item key="add_yu_zhong_record"> <a-icon type="check" />选用此配对</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px" size="small"> 操作 <a-icon type="down" /> </a-button>
        </a-dropdown>
      </template>
    </a-table>
    <a-modal :visible="show_confirm" title="选择确认">
      <template slot="footer">
        <a-button key="back" @click="show_confirm=false;picked_item={}">
          取消
        </a-button>
        <a-button key="submit" type="primary" @click="onConfirm">
          确认
        </a-button>
      </template>
      <a-row>
        <a-col :span="12">
          <a-descriptions title="雄性个体">
            <a-descriptions-item label="vid">
              {{ male_item.vid }}
            </a-descriptions-item>
          </a-descriptions>
        </a-col>
        <a-col :span="12">
          <a-descriptions title="雌性个体">
            <a-descriptions-item label="vid">
              {{ picked_item.vid }}
            </a-descriptions-item>
          </a-descriptions>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import ItemButton from '../../components/ItemButton.vue'
import yuZhongChartResult from './yuZhongChartResult.vue'
export default {
  components: {yuZhongChartResult, ItemButton},
  props: {
    male_item: {
      type: Object, default: () => {}
    },
    useInbreedingAlgo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pagination: {
        current: 1
      },
      list: [],
      picked_item: {},
      show_confirm: false,
      showLoading: false,
      columns: [
        {
          title: "Id",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "Vid",
          dataIndex: "vid",
          key: "vid",
          scopedSlots: {customRender: 'vid'}
        },
        {
          title: "出口号",
          dataIndex: "export_tag",
          key: "export_tag",
          scopedSlots: {customRender: 'export_tag'}
        },
        {
          title: "RF-Id",
          dataIndex: "rf_id",
          key: "rf_id",
          scopedSlots: {customRender: 'rf_id'}
        },
        {
          title: "父亲",
          dataIndex: "father",
          key: "father",
          scopedSlots: {customRender: 'father'}
        },
        {
          title: "母亲",
          dataIndex: "mother",
          key: "mother",
          scopedSlots: {customRender: 'mother'}
        },
        {
          title: "出生日期",
          dataIndex: "birth_date",
          key: "birth_date",
          scopedSlots: {customRender: 'birth_date'}
        },
        {
          title: "GEBV",
          dataIndex: "gebv_volume",
          key: "gebv_volume",
          scopedSlots: {customRender: 'gebv_volume'}
        },
        {
          title: "预测后代近交系数",
          dataIndex: "predicted_offspring_f",
          key: "predicted_offspring_f",
          width: 150,
          scopedSlots: {customRender: 'predicted_offspring_f'},
          sorter: (a, b) => (a.predicted_offspring_f || 0) - (b.predicted_offspring_f || 0),
        },
        {
          title: "状态",
          key: "state",
          scopedSlots: {customRender: 'state'}
        },
        {title: '操作', key: 'operation', scopedSlots: { customRender: 'operation' } }
      ]
    }
  },
  created() {
    if (this.male_item.id) {
      this.$api.get_breed_item_by_id(this.male_item.id).then(res => {
        this.male_item = res.data
      })
    }
  },
  computed: {
    visibleColumns() {
      // 预测后代近交系数列在近交模式下始终显示，传统模式下隐藏
      const baseColumns = this.columns.filter(col => col.dataIndex !== 'predicted_offspring_f')
      if (this.useInbreedingAlgo) {
        // 插入到 GEBV 列之后
        const gebvIndex = baseColumns.findIndex(col => col.dataIndex === 'gebv_volume')
        const predictedCol = this.columns.find(col => col.dataIndex === 'predicted_offspring_f')
        if (predictedCol && gebvIndex >= 0) {
          baseColumns.splice(gebvIndex + 1, 0, predictedCol)
        }
      }
      return baseColumns
    }
  },
  methods: {
    syncData(list, pagination) {
      this.list = list
      this.pagination = pagination
    },
    formatInbreeding(val) {
      if (val === null || val === undefined) return '待计算'
      return Number(val).toFixed(4)
    },
    getInbreedingColor(val) {
      if (val === null || val === undefined) return '#999'
      const v = Number(val)
      if (v <= 0.03125) return '#52c41a'   // 绿色 - 安全 (<= 3.125%)
      if (v <= 0.0625) return '#fa8c16'    // 橙色 - 警告 (3.125% < F <= 6.25%)
      return '#f5222d'                     // 红色 - 禁止 (> 6.25%)
    },
    getInbreedingLevel(val) {
      if (val === null || val === undefined) return 'unknown'
      const v = Number(val)
      if (v <= 0.03125) return 'safe'
      if (v <= 0.0625) return 'warning'
      return 'danger'
    },
    inbreedingRowClass(record) {
      if (!this.useInbreedingAlgo) return ''
      const level = this.getInbreedingLevel(record.predicted_offspring_f)
      if (level === 'danger') return 'inbreeding-danger-row'
      if (level === 'warning') return 'inbreeding-warning-row'
      return ''
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.$emit("page-change", pagination.current)
    },
    onExpand(expanded, record) {
      this.$nextTick(() => {
        if (expanded) {
          this.$refs[`result-${record.vid}`].draw(this.male_item.id, record.id)
        }
      })
    },
    handleItemAction(e, item) {
      this.show_confirm = true
      this.picked_item = item
    },
    handleAddYuZhongConfirm(e, item) {
      if (e.key == 'add_yu_zhong_record') {
        const payload = {
          male_id: this.male_item.id,
          female_id: item.id,
          farm_id: item.farm_id
        };
        
        // 从路由参数中获取 group_type 和 cell ID（作为 item_select_record_id）
        const groupType = this.$route.query.group_type;
        const itemSelectRecordId = this.$route.params.id; // 路由中的 cell ID
        
        // 如果 group_type=selectRecord，则添加 item_select_record_id 参数
        if (groupType === 'selectRecord' && itemSelectRecordId) {
          payload.item_select_record_id = parseInt(itemSelectRecordId);
        }
        
        this.$api.post_yu_zhong_records(payload);
      }
    },
    onConfirm() {
      const payload = {
        male_id: this.male_item.id,
        female_id: this.picked_item.id,
        farm_id: this.picked_item.farm_id
      }
      
      // 从路由参数中获取 group_type 和 cell ID（作为 item_select_record_id）
      const groupType = this.$route.query.group_type;
      const itemSelectRecordId = this.$route.params.id; // 路由中的 cell ID
      
      // 如果 group_type=selectRecord，则添加 item_select_record_id 参数
      if (groupType === 'selectRecord' && itemSelectRecordId) {
        payload.item_select_record_id = parseInt(itemSelectRecordId);
      }
      
      this.$api.post_yu_zhong_records(payload).then(res => {
        if (res.code == 200) {
          this.$message.success("操作成功")
          this.show_confirm = false
          // 发送信号到父组件，通知刷新列表
          this.$emit('yu-zhong-record-added');
          // 关闭父级模态框
          this.$parent.show_yu_zhong_dialog = false;
          // 清空数据
          this.$parent.$refs.resultTable.syncData([], {});
        } else {
          this.$message.error("服务器开小差了，请重试")
        }
      })
    }
  },
}
</script>

<style scoped>
/* 近交警告行高亮 */
::v-deep .inbreeding-warning-row {
  background-color: #fffbe6 !important;
}
::v-deep .inbreeding-warning-row:hover > td {
  background-color: #fff1b8 !important;
}

/* 近交禁止行高亮 */
::v-deep .inbreeding-danger-row {
  background-color: #fff1f0 !important;
}
::v-deep .inbreeding-danger-row:hover > td {
  background-color: #ffccc7 !important;
}
</style>